import type { Me } from '@/shared/session/session';

import { reference, type DocsOperation } from './generated/reference';

/** Endpoint page for a `/docs/api/$tag/$operation` URL, or undefined for an unknown pair. */
export function findOperation(tagKey: string, slug: string): DocsOperation | undefined {
  return Object.values(reference.operations).find(
    (operation) => operation.tag === tagKey && operation.slug === slug,
  );
}

export function operationById(id: string): DocsOperation | undefined {
  return reference.operations[id];
}

/**
 * A member with the Developer role only sees the Developers group, so the organisation home
 * (reports, catalogue) has nothing for them and the docs are their landing page.
 */
export function landsOnDocs(me: Me): boolean {
  return me.role.key === 'developer';
}
